import { createContext } from "react";
import CreditCardIcon from "../../../../images/creadit-card-gray.png";
import MCashIcon from "../../../../images/m-cash-gray.png";
import BankTransferIcon from "../../../../images/bank-transfer-gray.png";
import CreditCardHighlightIcon from "../../../../images/creadit-card-yellow.png";
import BankTransferHighlightIcon from "../../../../images/bank-transfer-yellow.png";
import MCashHighlightIcon from "../../../../images/m-cash-yellow.png";

const PAYMENT_METHOD_VIEW = Object.freeze({
  PAYMENT_METHOD_SELECTOR: "PAYMENT_METHOD_SELECTOR",
  CARD_PAYMENT_SELECOTR: "CARD_PAYMENT_SELECOTR",
});

const PAYMENT_METHOD_ERROR = Object.freeze({
  NONE: "NONE",
  REQUIRED: "REQUIRED",
});

export const CHECKOUT_OPTIONS = [
  {
    id: "online_payment",
    label: "payment.onlinePayment",
    recurringAllowed: true,
    icon: { default: CreditCardIcon, selected: CreditCardHighlightIcon },
    activated: true,
  },
  {
    id: "bank_transfer",
    label: "payment.bankTransfer",
    recurringAllowed: false,
    icon: { default: BankTransferIcon, selected: BankTransferHighlightIcon },
    activated: false,
  },
  {
    id: "other",
    label: "payment.other",
    recurringAllowed: false,
    icon: { default: MCashIcon, selected: MCashHighlightIcon },
    activated: false,
  },
];

const PAYMENT_METHOD_ENUM = Object.freeze({
  LOCAL_CC: { id: "local_cc" },
  FOREIGN_CC: { id: "foreign_cc" },
  PAYPAL: { id: "paypal" },
  EZ_CASH: { id: "ez_cash" },
  FRIMI: { id: "frimi" },
  GENIE: { id: "genie" },
  M_CASH: { id: "m_cash" },
  VISHWA: { id: "vishwa" },
  AU_BANK: { id: "au_bank" },
  EU_BANK: { id: "eu_bank" },
  SL_BANK: { id: "sl_bank" },
  UK_BANK: { id: "uk_bank" },
  US_BANK: { id: "us_bank" },
});

export const PRICING_TIERS_ENUM = Object.freeze({
  "1m": { id: "1m", label: "1 Month" },
  "2m": { id: "2m", label: "2 Months" },
  "3m": { id: "3m", label: "3 Months" },
  "2m_basic": { id: "2m_basic", label: "2M Basic" },
  "3m_basic": { id: "3m_basic", label: "3M Basic" },
  "3m_pro": { id: "3m_pro", label: "3M Pro" },
  "6m_vip": { id: "6m_vip", label: "Premium" },
});

const CHECKOUT_OPTION_ENUM = Object.freeze({
  online_payment: {
    id: "online_payment",
    label: "payment.onlinePaymentNew",
    recurringAllowed: true,
    icon: { default: CreditCardIcon, selected: CreditCardHighlightIcon },
    // TODO: replace with supportedMethodsV2 and remove
    supportedMethods: ["local_cc", "foreign_cc"],
    supportedMethodsV2: {
      [PAYMENT_METHOD_ENUM.LOCAL_CC.id]: {
        id: [PAYMENT_METHOD_ENUM.LOCAL_CC.id],
        allowedOnlyContries: ["LK"],
        enabled: true,
      },
      [PAYMENT_METHOD_ENUM.FOREIGN_CC.id]: {
        id: [PAYMENT_METHOD_ENUM.FOREIGN_CC.id],
        allowedOnlyContries: [],
        enabled: true,
      },
    },
    activated: true,
  },
  bank_transfer: {
    id: "bank_transfer",
    label: "payment.bankTransferNew",
    recurringAllowed: false,
    icon: { default: BankTransferIcon, selected: BankTransferHighlightIcon },
    // TODO: replace with supportedMethodsV2 and remove
    supportedMethods: [],
    supportedMethodsV2: {
      // structure: [id]: { id: [id], allowedOnlyContries: [], enabled: boolean }
    },
    activated: false,
  },
  other: {
    id: "other",
    label: "payment.other",
    recurringAllowed: false,
    icon: { default: MCashIcon, selected: MCashHighlightIcon },
    // TODO: replace with supportedMethodsV2 and remove
    supportedMethods: [],
    supportedMethodsV2: {
      // structure: [id]: { id: [id], allowedOnlyContries: [], enabled: boolean}
    },
    activated: false,
  },
});

const PageConfig = {
  PAYMENT_METHOD_VIEW,
  CHECKOUT_OPTIONS,
  CHECKOUT_OPTION_ENUM,
  PAYMENT_METHOD_ENUM,
  PRICING_TIERS_ENUM,
  PAYMENT_METHOD_ERROR,
  ADD_PROMO_CODE_ACTIVATED: false,
};

const initialContext = {
  paymentLinkId: "",
  paymentMethodUI: PAYMENT_METHOD_VIEW.PAYMENT_METHOD_SELECTOR,
  setPaymentMethodUI: () => {},
  selectedPaymentMethod: {},
  setSelectedPaymentMethod: () => {},
  genericPaymentMethods: [],
  setGenericPaymentMethods: () => {},
  secondaryPaymentMethod: {},
  setSecondaryPaymentMethod: () => {},
  formErrors: {},
  setFormErrors: () => {},
  submitCount: 0,
  setSubmitCount: () => {},
  agreedToTerms: false,
  setAgreedToTerms: () => {},
  paymentLinkData: {},
  setPaymentLinkData: () => {},
  promoCode: "",
  setPromoCode: () => {},
  currency: "",
  setCurrency: () => {},
  shouldApplyPromoCode: false,
  setShouldApplyPromoCode: () => {},
};

export const PageContext = createContext(initialContext);

export default PageConfig;
